import React from 'react';
import {connect} from "react-redux";
import {withRouter} from "react-router-dom";
import RemoveGroceryList from "../../components/RemoveGroceryList";
import {PdfGroceryList} from "../../components/pdfGroceryList";
import {PDFViewer} from "@react-pdf/renderer";
import {Grid, LinearProgress} from "@material-ui/core";


/**
 * This class contain a material table, contains user's ingredients
 * user could delete them from is list
 */
class Ingredients extends React.Component {
    state = {
        ingredients: null,
    };

    componentDidMount = async () => {
        const user = await this.props.auth;
        const ingredients = user.ingredients;
        this.setState({ingredients, isLoading: false});
    };

    render() {
        const {ingredients} = this.state;
        if (!ingredients) return <LinearProgress/>;

        return (
            <>
                    {this.props.auth.myList ?
                        <Grid container justify='center'>
                            <RemoveGroceryList/>
                            <Grid item xs={12}>
                                <PDFViewer style={{width:"100%", height: "90vh"}}>
                                    <PdfGroceryList list={this.props.auth.myList}/>
                                </PDFViewer>
                            </Grid>
                        </Grid>
                        :  <Grid container justify="center" >il semble que votre liste de course est vide pour le moment</Grid>}
            </>
        );
    }
}


const mapStateToProps = ({auth}) => {
    return {auth}
};

export default withRouter(connect(
    mapStateToProps,
    null
)(Ingredients))
